import '.gj{width:2.5rem;}.ssr-plugin'
import '.b0{height:2.5rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.aq{justify-content:center;}.ssr-plugin'
import '.gk{color:var(--palette-blue-700);}.ssr-plugin'
import '.gl{font-size:0.9rem;}.ssr-plugin'
import '.a5{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { LinkAnchor } from '@app/components/core/link/LinkAnchor'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  to?: string
  onClick?: MouseEventHandler<HTMLElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  to,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
  const sharedStyle: Style = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.5rem',
    cursor: 'pointer',
    padding: '0.75rem',
    borderRadius: '1.25rem',
    border: 'var(--border-subtle)',
    backgroundColor: 'var(--palette-white)',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'var(--palette-blue-50)',
    },
    width: isMobile ? '8rem' : '5.5rem',
    height: isMobile ? '8rem' : '5.5rem',
  }

  const content = (
    <>
      <div className="gj b0 a t aq gk"
        style={{
          fontSize: isMobile ? '3rem' : '2rem',
        }}
      >
        <FontAwesomeIcon icon={icon} />
      </div>
      <span className="gl gk a5"
      >
        {label}
      </span>
    </>
  )

  if (to) {
    return (
      <LinkAnchor to={to} onClick={onClick} style={sharedStyle}>
        {content}
      </LinkAnchor>
    )
  }

  return (
    <styled.button onClick={onClick} style={sharedStyle} type="button">
      {content}
    </styled.button>
  )
}
